import { FetchPolicy, LazyQueryExecFunction } from '@apollo/client';
import useWorkspace from '@app/features/Workspace/store/hooks/useWorkspace';
import {
  GetUsersQuery,
  GetUsersQueryVariables,
  useGetUsersLazyQuery,
  useGetUsersQuery,
} from '@app/types/blackroom-api';
import { PermissionKey } from '@app-types/blackroom-api';
import { QueriedUser } from '../types';

export function useWorkspaceUsers({
  fetchPolicy = 'cache-first',
  withPermission,
}: {
  fetchPolicy?: FetchPolicy;
  withPermission?: PermissionKey;
} = {}): {
  data: QueriedUser[];
  refetch: LazyQueryExecFunction<GetUsersQuery, GetUsersQueryVariables>;
} {
  const workspace = useWorkspace();

  const variables: GetUsersQueryVariables = {
    filter: {
      workspaceId: workspace.id,
      ...(withPermission !== undefined && {
        withPermission,
      }),
      isSuspended: false,
    },
    workspaceId: workspace.id,
  };

  const { data } = useGetUsersQuery({ variables: variables, fetchPolicy });
  const [refetch] = useGetUsersLazyQuery({
    variables: variables,
    fetchPolicy: 'network-only',
  });

  return {
    data: data?.users.nodes ?? [],
    refetch,
  };
}
